import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=9b8cae22&scoped=true"
import script from "./tree.vue?vue&type=script&lang=ts"
export * from "./tree.vue?vue&type=script&lang=ts"
import style0 from "./tree.vue?vue&type=style&index=0&id=9b8cae22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8cae22",
  null
  
)

export default component.exports